import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueResource from 'vue-resource'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies'
import 'xe-utils'
import VueCarousel from 'vue-carousel';
// import VueI18n from 'vue-i18n'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
// import enUS from 'vxe-table/lib/locale/lang/en'
import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;
Vue.use(VueResource)
Vue.use(Vuelidate)
Vue.use(VueCookies)
Vue.$cookies.config('30min')
Vue.use(VueCarousel)
Vue.use(VXETable)
// Vue.use(VueHtmlToPaper)
Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
}
// const messages = {
//   en_US: {
//     ...enUS
//   }
// }
// const i18n = new VueI18n({
//   locale: 'en_US',
//   messages,
// })
// Vue.use(VXETable, {
//   i18n: key => i18n.t(key)
// })
Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});
// router.beforeEach((to, from, next) => {
//   if (to.path != '/login') {
//     if (!window.sessionStorage.getItem("username")) {
//       next({
//         path: '/login'
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })
const app = new Vue({
  el: '#app',
  router: router,
  components: { App },
  render: h => h(App)
});
